module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAQAQMAAAALeEywAAAAA1BMVEUre8tTHy/eAAAACklEQVQI12MgAAAAIAABneNbxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_tag.png
// module id = QSLJ
// module chunks = 9